"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseFilterModel2 = _interopRequireDefault(require("./BaseFilterModel"));

var _mobx = require("mobx");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _FormModel = _interopRequireDefault(require("../../FormModel"));

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var TypeaheadFilterModel = (_class = /*#__PURE__*/function (_BaseFilterModel) {
  _inherits(TypeaheadFilterModel, _BaseFilterModel);

  var _super = _createSuper(TypeaheadFilterModel);

  function TypeaheadFilterModel(definition) {
    var _this;

    _classCallCheck(this, TypeaheadFilterModel);

    _this = _super.call(this, definition);

    _initializerDefineProperty(_assertThisInitialized(_this), "typeaheadForm", _descriptor, _assertThisInitialized(_this));

    _this.endpoint = definition.endpoint;
    _this.typeaheadForm = new _FormModel.default({});
    return _this;
  }

  _createClass(TypeaheadFilterModel, [{
    key: "key",
    get: function get() {
      return this.definition.name || "typeahead";
    }
  }, {
    key: "func",
    get: function get() {
      var _this2 = this;

      return function (rowData) {
        var rowValue = rowData.get(_this2.columnName);

        if ((0, _isFunction.default)(_this2.definition.compareFunction)) {
          return _this2.definition.compareFunction(rowValue, _this2.value);
        } else {
          return !(0, _isNull.default)(rowValue) && rowValue.toString().toLowerCase() === _this2.value.toLowerCase();
        }
      };
    }
  }, {
    key: "typeaheadValue",
    get: function get() {
      return this.typeaheadForm.get("typeaheadValue");
    }
  }, {
    key: "defaultValue",
    get: function get() {
      return _get(_getPrototypeOf(TypeaheadFilterModel.prototype), "defaultValue", this) || "";
    }
  }, {
    key: "updateValue",
    value: function updateValue(newValue) {
      this.typeaheadForm.set("typeaheadValue", newValue);
      this.value = this.typeaheadForm.get("typeaheadValue");
    }
  }]);

  return TypeaheadFilterModel;
}(_BaseFilterModel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "typeaheadForm", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "func", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "func"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "typeaheadValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "typeaheadValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateValue"), _class.prototype)), _class);
var _default = TypeaheadFilterModel;
exports.default = _default;